<template>
  <div class="md:grid md:grid-cols-6 gap-16 mb-16">
    <div class="col-span-2" v-if="tabs.length > 1">
      <div class="lg:max-w-xs">
        <ul class="lg:space-y-1">
          <li v-for="(tab, index) in tabs" :key="index">
            <a
              href="#"
              v-scroll-to="{
                el: `#${tab.name.toLowerCase().replace(/ /g, '-')}`,
                offset: -100,
              }"
              :class="{ 'border-primary-100 bg-primary-50 dark:bg-primary-900': tab.isActive }"
              class="flex justify-between cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors p-2 px-4 -mx-4 lg:rounded-full block outline-none"
              @click="selectTab(tab)"
            >
              <span class="font-bold">{{ tab.name }}</span>
              <span class="text-sm ml-2">{{ tab.count }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div
      :class="{ 'mb-4 col-span-4': tabs.length > 1}"
    >
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tabs',
  data () {
    return {
      tabs: []
    }
  },
  created () {
    this.tabs = this.$children
  },
  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach((tab) => {
        tab.isActive = (tab.name === selectedTab.name)
      })
      this.$emit('changed', { tab: selectedTab.name })
    }
  }
}
</script>
